import { buildAnalyzePrompt } from '@cast/features-organization-shared-opspilot';

type BuildCostReportAnalyzePromptConfig = {
  scopeName?: string | null;
  context?: string;
  getDefaultRange: (() => { from: string; to: string }) | undefined;
};

export const buildCostReportAnalyzePrompt =
  ({
    scopeName,
    context = 'cloud cost',
    getDefaultRange,
  }: BuildCostReportAnalyzePromptConfig) =>
  (range?: { from: number; to: number }): string | null => {
    if (!scopeName) return null;
    return buildAnalyzePrompt({ context, scopeName, getDefaultRange })(range);
  };
